/**
  * @param htmlObject formElement - html form element.
  * @param object options - Optional parameters.
  * @param object strings - Al text strings in javascript (useful for translations).
  * @param object ajaxUrls - Al urls used for ajax requests.
  */

function Form(formWrapperElement, ajaxUrls, notifications){
	this.formWrapperElement = formWrapperElement;
	this.formElement = formWrapperElement.querySelector('form');
	this.ajaxUrls = ajaxUrls;
	this.notifications = ( Array.isArray( notifications ) ? notifications : null );
	this.formId = this.formWrapperElement.getAttribute('data-id');
	
	if(this.formElement.nodeName != 'FORM' ){
		return;
	}

	// binds
	this.processFormData = this.processFormData.bind(this);
	this.submitForm = this.submitForm.bind(this);
	this.processSubmitForm = this.processSubmitForm.bind(this);

	this.formElement.classList.add('js-active');

	// make a formData object to interact with the fields (could replace more code)
	this.formData = new FormData(this.formElement);

	this.formElement.addEventListener('submit', this.submitForm);

	// main data array
	this.formFields = [];

	if(this.formId){
		this.formDataRequest = new XMLHttpRequest();
		this.formDataRequest.addEventListener('readystatechange', this.processFormData);

		let postData = 'form_id=' + this.formId;
		
		this.formDataRequest.open('POST', this.ajaxUrls.formData);
		this.formDataRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
		this.formDataRequest.send(postData);
	}

	// submit request
	this.submitRequest = new XMLHttpRequest();
	this.submitRequest.addEventListener('load', this.processSubmitForm);

	this.setStatus('loading');
}

Form.prototype.getFormInputByName = function(name){
	for(let i=0;i<this.formFields.length;i++){
		if(this.formFields[i].data.name == name){
			return this.formFields[i];
		}
	}
};


/**
 * Get form inputs by searching for input name through conditionals.
 * @param  string. name. input name inside conditional.
 * @return object. Form input object.
 * @author Niels Riekert
 */

Form.prototype.getFormInputByConditional = function(name){
	let formInputs = [];

	for(let i=0;i<this.formFields.length;i++){
		if(!this.formFields[i].data.conditional){
			continue;
		}

		const conditional = this.formFields[i].data.conditional;

		let found = false;
		for(let j=0;j<conditional.length;j++){
			for(let k=0;k<conditional[j].length;k++){
				if(conditional[j][k].name == name){
					found = true;
					formInputs.push(this.formFields[i]);
					break;
				}
			}
			if(found == true){
				break;
			}
		}
	}

	return formInputs;
};

Form.prototype.getFormFieldsByGroup = function(name){
	let foundFormFields = [];
	for(let i=0;i<this.formFields.length;i++){
		if(this.formFields[i].data.group && this.formFields[i].data.group.name == name){
			foundFormFields.push(this.formFields[i]);
		}
	}
	return foundFormFields;
};

Form.prototype.getEventChangeType = function(formElement){
	if(formElement.nodeType != 1){
		return false;
	}

	let event = '';
	let type = '';
	if(formElement.nodeName.toLowerCase() == 'input'){
		switch(formElement.getAttribute('type')){
			case 'radio':
			case 'checkbox':
				type = formElement.getAttribute('type').toLowerCase();
				break;
			default:
				type = formElement.nodeName.toLowerCase();
				break;
		}
	}
	else {
		type = formElement.nodeName.toLowerCase();
	}

	switch(type){
		case 'select':
			event = 'change';
			break;
		case 'radio':
			event = 'click';
			break;
		default :
			event = 'keyup';
			break;
	}

	return event;
};

Form.prototype.setFieldConditional = function(formInput, bubble = true){
	if(!formInput.data.conditional){
		return;
	}
	
	if(typeof Hooks === 'function'){
		const hooks = new Hooks();
		hooks.triggerAction('setFieldConditional', [this, formInput]);
	}

	const conditional = formInput.data.conditional;

	let showField = false;
	// loop through OR group conditionals
	for(let i=0;i<conditional.length;i++){
		let andMet = true;
		// loop through AND group conditionals
		for(let j=0;j<conditional[i].length;j++){
			const conditionalFormInput = this.getFormInputByName(conditional[i][j].name);
			const conditionalInputValue = conditionalFormInput.getValue();

			if(!conditionalFormInput){
				console.error('Form input by name from the conditional not found: "' + conditional[i][j].name + '" for: "' + formInput.data.name + '"');
				return;
			}

			if(conditionalInputValue == null){
				console.error('Field value by name from the conditional not found: "' + conditional[i][j].name + '" for: "' + formInput.data.name + '"');
				return;
			}

			if(conditionalFormInput.isHidden() || this.processConditional(conditionalInputValue, conditional[i][j].operator, conditional[i][j].value) !== true){
				andMet = false;
				break;
			}
		}

		if(andMet === true){
			showField = true;
		}
	}
	
	if(showField === true){
		formInput.setStatus('show');
	}
	else {
		formInput.setStatus('hidden');
	}

	if(bubble){
		let formInputs = this.getFormInputByConditional(formInput.data.name);
		
		for(let i=0;i<formInputs.length;i++){
			this.setFieldConditional(formInputs[i]);
		}
	}
};

Form.prototype.setStatus = function(status){
	switch(status){
		case 'loading':
			this.formElement.classList.add('is-loading');
			break;
		case 'hidden':
			this.formElement.classList.add('is-hidden');
			break;
		case 'visible':
			this.formElement.classList.remove('is-hidden');
			break;
		case 'reset':
			this.formElement.classList.remove('is-loading');
			break;
	}
};


/**
 * Processes the JSON data that makes up the form.
 * 
 * @author Niels Riekert
 */

Form.prototype.processFormData = function(){
	if(this.formDataRequest.readyState != 4) return;
	if(this.formDataRequest.status != 200 && this.formDataRequest.status != 304) {
		console.log('HTTP error ' + this.formDataRequest.status);
		return;
	}

	const formData = JSON.parse(this.formDataRequest.responseText);

	this.name = formData.name;

	for(let i=0;i<formData.fields.length;i++){
		const containerElement = this.formElement.querySelector('[data-name="' + formData.fields[i].name + '"]');

		let field = new FormField(this, formData.fields[i], containerElement, this.ajaxUrls);
		
		this.formFields.push(field);
	}

	// setup event handlers for conditional fields
	for(let i=0;i<this.formFields.length;i++){
		if(!this.formFields[i].data.conditional){
			continue;
		}
		this.setFieldConditional(this.formFields[i], false);

		const conditional = this.formFields[i].data.conditional;
		const formField = this.formFields[i];

		for(let j=0;j<conditional.length;j++){
			for(let k=0;k<conditional[j].length;k++){
				const conditionalFormInput = this.getFormInputByName(conditional[j][k].name);
				if(!conditionalFormInput){
					console.error('Form field by name from the conditional not found: "' + conditional[j][k].name + '" for: "' + formField.data.name + '"');
					continue;
				}

				let formElements = conditionalFormInput.getFormElements();
				
				for(let l=0;l<formElements.length;l++){
					formElements[l].addEventListener(this.getEventChangeType(formElements[l]), function(){
						this.setFieldConditional(formField);
					}.bind(this));
				}
			}
		}
	}

	this.setStatus('reset');
};

Form.prototype.processConditional = function(value, operator, conditionalValue){
	switch(operator){
		case '!=':
			return (value != conditionalValue);
		case '==':
			return (value == conditionalValue);
		case '>':
			return (value > conditionalValue);
		case '<':
			return (value < conditionalValue);
	}

	return null;
};

Form.prototype.submitForm = function(event){
	event.preventDefault();

	// check for existing active submit request
	if(this.submitRequest.readyState != 4 && this.submitRequest.readyState != 0){
		 return;
	}

	this.formData = new FormData(this.formElement);

	this.formFields.forEach((formField) => {
		if(this.formData.set){// check if function exists
			this.formData.set(formField.data.name, formField.getValue(true));
		}
		else {
			this.formData.append(formField.data.name, formField.getValue(true));
		}
	});

	if(this.formData.set){// check if function exists
		this.formData.set('form_id', this.formId);
		this.formData.set('source_url', window.location.href);
		if( Array.isArray( this.notifications ) ) {
			this.formData.set('notifications', this.notifications.join(',') );
		}
	}
	else {
		this.formData.append('form_id', this.formId);
		this.formData.append('source_url', window.location.href);
		if( Array.isArray( this.notifications ) ) {
			this.formData.append('notifications', this.notifications.join(',') );
		}
	}

	this.submitRequest.open('POST', this.ajaxUrls.submitForm);
	//this.submitRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	this.submitRequest.send(this.formData);

	this.setStatus('loading');
};

Form.prototype.processSubmitForm = function(event){
	if(this.submitRequest.readyState != 4) return;
	if(this.submitRequest.status != 200 && this.submitRequest.status != 304) {
		console.log('HTTP error ' + this.submitRequest.status);
		return;
	}

	this.setStatus('reset');

	const submitResponse = JSON.parse(this.submitRequest.responseText);

	if(typeof Hooks === 'function'){
		const hooks = new Hooks();
		hooks.triggerAction('formSubmitted', [this, submitResponse]);
	}
	
	if(submitResponse.validations){
		this.formFields.forEach((formField) => {
			if(submitResponse.validations[formField.data.name]){
				formField.setValidation(submitResponse.validations[formField.data.name]);
			}
		});
	}

	if(submitResponse.onSuccesUrl){
		window.location = submitResponse.onSuccesUrl;
	}
	else if(submitResponse.formValidated && submitResponse.saveResult){
		const messageElement = document.createElement('div');
		messageElement.setAttribute('class', 'form-succes-message');
		messageElement.innerHTML = (submitResponse.onSuccesMessage) ? submitResponse.onSuccesMessage : '<p>Thank you</p>';
		this.setStatus('hidden');
		this.formWrapperElement.appendChild(messageElement);
		
		if(typeof Hooks === 'function'){
			const hooks = new Hooks();
			hooks.triggerAction('formSubmitMessageDisplayed', [this, messageElement]);
		}
	}
};

export default Form;